/* eslint-disable no-else-return */
import React from 'react';
import { connect } from 'react-redux';
import BuyerRestrictedHeader from './BuyerRestrictedHeader';
import AdminRestrictedHeader from './AdminRestrictedHeader';
import SellerRestrictedHeader from './SellerrestrictedHeader';
import { useIsAlternativeAuction } from '../../../../hooks';

const RoleRestrictedSection = ({ role, isAlternativeAuction }) => {
  if (role === 'buyer' && !isAlternativeAuction) {
    return <BuyerRestrictedHeader />;
  } else if (role === 'admin') {
    return <AdminRestrictedHeader />;
  } else if (role === 'seller' && !isAlternativeAuction) {
    return <SellerRestrictedHeader />;
  }
  return null;
};

export default connect(state => ({
  role: (state.user.user || {}).role
}))(RoleRestrictedSection);
